import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { getActivityInformations } from '@/api/common';
import { ref, onMounted, computed } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getDefaultRewards, getTodayData, sumAmounts } from '@/utils/commonFunction';
import { getDailyRechargeRewardsClaim } from '@/api/activity';
import { useUserStore } from '@/stores/user';
import { DailyGift, FutureRewards, PAGE_SIZE, RechargeGiftData } from './supportScript';
import RechargeGiftOne from '@/themes/themeOne/rechargeGift/rechargeGift.vue';
import RechargeGiftTwo from '@/themes/themeTwo/rechargeGift/rechargeGift.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'rechargeGift',
  setup(__props) {

const themeStore = useThemeStore()
const userStore = useUserStore()
const isSuccess = ref(false)
const statusRef = ref();
const toastContent = ref('');
const loadingRef = ref();

const todayRechargeGiftDetails = ref<DailyGift>({
    day: 0,
    gift_rate: 0,
    turnover_times: 0,
    createTime: '',
    activeStatus: 0,
    dayOne: 0,
    dayTwo: 0,
    dayThree: 0,
    dayFour: 0,
    dayFive: 0,
    daySix: 0,
    daySeven: 0,
    status: 0,
    availableAmount: 0,
    givenAmount: 0,
    rewards: [],
});
const historyList = ref<DailyGift[]>([])
const activityDescription = ref<string[]>([]);
const total = ref(0)
const pageNum = ref(1)
const pageSize = ref(PAGE_SIZE)
const weeklyRechargeGiftList = ref<DailyGift[]>([])
const cashbackTotal = ref(0)
const futureRewards = ref<FutureRewards[]>([])
const bannerIcon = ref('')

const dataSet = computed<RechargeGiftData>(() => ({
    todayRechargeGiftDetails: todayRechargeGiftDetails.value,
    historyList: historyList.value,
    activityDescription: activityDescription.value,
    total: total.value,
    pageNum: pageNum.value,
    pageSize: pageSize.value,
    weeklyRechargeGiftList: weeklyRechargeGiftList.value,
    cashbackTotal: cashbackTotal.value,
    futureRewards: futureRewards.value,
    bannerIcon: bannerIcon.value,
}))
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "RECHARGE_GIFT",
        pageNum: pageNum.value,
        pageSize: 7
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        bannerIcon.value = res.data?.floatIcon
        weeklyRechargeGiftList.value = res.data.config.rows
        todayRechargeGiftDetails.value = weeklyRechargeGiftList.value ? getTodayData(weeklyRechargeGiftList.value) : {}
        let days = JSON.parse(res.data?.activityConfig)?.recharge_gift_config.length 
        futureRewards.value = todayRechargeGiftDetails.value ? todayRechargeGiftDetails.value?.rewards : getDefaultRewards(days)

        if (!todayRechargeGiftDetails.value) {
            const today = new Date().toISOString().split('T')[0];
            let defaultData = {
                day: 0,
                gift_rate: 0,
                turnover_times: 0,
                createTime: today + ' 00:00:00',
                activeStatus: 0,
                dayOne: 0,
                dayTwo: 0,
                dayThree: 0,
                dayFour: 0,
                dayFive: 0,
                daySix: 0,
                daySeven: 0,
                status: 0,
                availableAmount: 0,
                givenAmount: 0,
                rewards: [],
            }
            todayRechargeGiftDetails.value = defaultData
            futureRewards.value = getDefaultRewards(days)
        }
        cashbackTotal.value = sumAmounts(futureRewards.value)
        activityDescription.value = JSON.parse(res.data.activityIntro);
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getNextPageRewardData = () => {
    if (total.value > pageSize.value * pageNum.value) {
        loadingRef.value.open()
        pageNum.value = pageNum.value + 1
        getHistoryList()
    }
}
const getHistoryList = () => {
    loadingRef.value.open();
    let data = {
        activityId: "RECHARGE_GIFT",
        pageNum: pageNum.value,
        pageSize: pageSize.value
    }
    getActivityInformations(data).then((res: any) => {
        historyList.value = [...historyList.value, ...res.data.config.rows]
        total.value = res.data.config.total
        loadingRef.value.close();
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const resetHistoryData = () => {
    total.value = 0
    pageNum.value = 1
    historyList.value = []
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const getClaim = () => {
    let data = {
        uid: userStore.id
    }
    loadingRef.value.open();
    getDailyRechargeRewardsClaim(data).then((res: any) => {
        loadingRef.value.close();
        showSuccess(res.msg)
        loadingRef.value.open();
        getActivityInfo()
    }).catch(err => {
        loadingRef.value.close();
        showError(err);
    })
}
onMounted(() => {
    getActivityInfo()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(RechargeGiftOne, {
            "data-set": dataSet.value,
            onGetClaim: getClaim,
            onGetHistoryList: getHistoryList,
            onGetNextPageRewardData: getNextPageRewardData,
            onResetHistoryData: resetHistoryData
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(RechargeGiftTwo, {
            "data-set": dataSet.value,
            onGetClaim: getClaim,
            onGetHistoryList: getHistoryList,
            onGetNextPageRewardData: getNextPageRewardData,
            onResetHistoryData: resetHistoryData
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})